import React, { useState } from 'react'
import { Icon, Tab, Tabs } from '@blueprintjs/core'
import { Card } from '../../components/ui/card'
import { Metric } from './onboard'
import { MyHTMLTable } from '../../packages/blueprint-components/src/HTMLTable'
import { CardHeader } from '../../components/ui/CardHeader'
import { Checkbox } from '../../components/ui/checkbox'

const BackButton = (onClick) => {
    return (
        <span onClick={() => (onClick ? onClick() : null)}>
            <Icon icon={<Icon icon="arrow-left" className="mr-2" />} />
        </span>
    )
}

export const Product = () => {
    const [activeTab, setActiveTab] = useState('campaigns')

    return (
        <Card className="bp4-card-rounded p-0">
            <CardHeader className="py-0">
                <div className="d-flex align-items-center">
                    <BackButton />
                    <span>B037SG678H</span>
                </div>
                <div className="d-flex align-items-end h-100 flex-grow-1">
                    <Tabs
                        className="w-100 custom-tabs justify-content-center"
                        d-flex
                        onChange={(active) => setActiveTab(active)}
                        selectedTabId={activeTab}
                    >
                        <Tab id="campaigns" title="Campaigns" />
                        <Tab id="keywords" title="Keywords" />
                        <Tab id="search_terms" title="Search Terms" />
                    </Tabs>
                </div>
            </CardHeader>
            <div className="p-4">
                {activeTab === 'campaigns' && <CampaignPanel />}
                {activeTab === 'keywords' && <KeywordsPanel />}
                {activeTab === 'search_terms' && <SearchTermsPanel />}
            </div>
        </Card>
    )
}

const CampaignPanel = ({}) => {
    return (
        <div>
            <div className="d-flex justify-content-between mb-4">
                <CampaignSpeedometer
                    name="Automatic"
                    allocation={25}
                    utilization={80}
                    spend={125}
                />
                <CampaignSpeedometer name="Testing" allocation={40} utilization={40} spend={30} />
                <CampaignSpeedometer
                    name="Performance"
                    allocation={35}
                    utilization={100}
                    spend={70}
                />
            </div>
            <div>
                <DummyTable />
            </div>
        </div>
    )
}

const KeywordsPanel = ({}) => {
    const keywords = ['first', 'second', 'third', 'fourth', 'fifth']

    return (
        <div>
            <div className="d-flex justify-content-between mb-4">
                <CampaignKeywords name="Automatic" keywords={keywords} />
                <CampaignKeywords name="Testing" keywords={keywords} />
                <CampaignKeywords name="Performance" keywords={keywords} />
            </div>
            <div>
                <DummyTable />
            </div>
        </div>
    )
}

const SearchTermsPanel = ({}) => {
    return (
        <div>
            <div className="d-flex justify-content-between mb-4">search terms here</div>
            <div>
                <DummyTable />
            </div>
        </div>
    )
}

const CampaignSpeedometer = ({ name, allocation, utilization, spend }) => {
    return (
        <div>
            <h5 className="mb-3">{name}</h5>
            <Card className="p-3">
                <Metric className="mb-4" value={allocation + '%'} type="Allocation" />
                <div className="d-flex mb-3">
                    <Metric className="ml-4 mr-4" value={utilization + '%'} type="Utilization" />
                    <Metric
                        className="mr-4"
                        value={window.marketplace.currency_symbol + spend}
                        type="Spend"
                    />
                </div>
            </Card>
        </div>
    )
}

const CampaignKeywords = ({ name, keywords }) => {
    return (
        <div>
            <h5 className="mb-3">{name}</h5>
            <Card className="py-3 px-4">
                {keywords.map((keyword) => (
                    <div key={keyword.id}>{keyword}</div>
                ))}
            </Card>
        </div>
    )
}

const DummyTable = () => {
    return (
        <MyHTMLTable
            className="merchjar-table"
            columns={[
                {
                    title: ' ',
                    cell: () => <Checkbox className="mb-0" />,
                },
                'asin',
                'status',
                'campaign_rules',
                'match_type',
                'product_tags',
            ]}
            items={[
                {
                    asin: 'BOOKBOOK12',
                    status: 'paused',
                    campaign_rules: 'aggressive',
                    match_type: 'broad',
                    product_tags: 'christmas',
                },
                {
                    asin: 'BOOKBOOK12',
                    status: 'paused',
                    campaign_rules: 'aggressive',
                    match_type: 'broad',
                    product_tags: 'christmas',
                },
                {
                    asin: 'BOOKBOOK12',
                    status: 'paused',
                    campaign_rules: 'aggressive',
                    match_type: 'broad',
                    product_tags: 'christmas',
                },
            ]}
        />
    )
}
